
function searchParser (search) {
    const parsed = new DOMParser().parseFromString(search, 'text/html');
    return parsed.documentElement.innerText.replace(/\n/g, '');
}

export default searchParser;
